import React, { useState } from "react"
import { Button, Container, Menu } from "@mui/material"


const Partnermessage = ({ message }) => {

    const [anchorEl, setAnchorEl] = useState('');
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    }; 


    return (
        <div>
            <div style={{cursor:"pointer"}} onClick={handleClick} >{message.substring(0, 20)}...</div>
            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                PaperProps={{ sx: { width: '400px', height: '350px' } }}
            >
                <Container maxWidth="md" sx={{ width: "100%" }} >
                    {message}
                </Container>
            </Menu>
        </div>
    )
}

export default Partnermessage